module.exports = __webpack_public_path__ + "static/logo-vertical-17c7c12f29f408cfd467c217b7e74218.svg";